import { render } from "./PaymentPercentage.vue?vue&type=template&id=829d2528&scoped=true&ts=true"
import script from "./PaymentPercentage.vue?vue&type=script&lang=ts"
export * from "./PaymentPercentage.vue?vue&type=script&lang=ts"

import "./PaymentPercentage.vue?vue&type=style&index=0&id=829d2528&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-829d2528"]])

export default __exports__